<template>
  <div :style="{'height':height+'px'}" class="product-detail">
    <CreateMianLiao @setModalState="setModalState" @setFormData="setFormData" :productInfo="productInfoTemp" :productModalshow="showDetailModal" />
    <div v-if="productInfo.id" style="padding-bottom:50px">
      <van-sticky offset-top="10">
        <van-icon @click="back" class="back-icon" name="arrow-left"/>
      </van-sticky>
      <van-swipe :autoplay="3000">
        <van-swipe-item :key="index" v-for="(item, index) in imgs">
          <img v-lazy="productInfo[item]"/>
        </van-swipe-item>

      </van-swipe>
      <div class="info">
        <div class="title">{{ productInfo.number }}</div>
        <!--<div class="menfu">门幅：{{ design.zhuBuSpec }}</div>
        <div class="desc">
          <span v-if="design.zhuBuProductName">主布：{{ design.zhuBuProductName }}</span>
          <span v-if="design.peiBuProductName">配布：{{ design.peiBuProductName }}</span>
        </div>-->
      </div>
      <div class="img-detail">
        <img v-lazy="productInfo.descriptionImageUrl"/>
      </div>
    </div>
    <van-goods-action v-if="productInfo.number">

      <van-goods-action-icon style="flex:1" icon="cart-o" text="前往购物车" @click="onClickIcon"/>
       <van-goods-action-button
          type="danger"
          text="加入购物车"
          @click="onClickButton"
      />

<!--      <div class="total"><span>¥{{total}}</span> <div>合计</div></div>-->
    </van-goods-action>
  </div>
</template>
<script>
import CreateMianLiao from '@/components/CreateMianLiao.vue';

export default {
  name: "productDetail",
  components: {
    CreateMianLiao
  },
  data() {
    return {
      designInfoTemp: {},
      designInfo: {
        imageOne:"https://beeda-curtain.oss-cn-beijing.aliyuncs.com/design/003ffeeb01114cb88b3a915bed027a63-Thumbnail.png",
        name:"TL002"
      },
      productInfoTemp: {},
      productInfo: {},
      showDetailModal: false,
      height: 0,
      total:0,
      imgs: ['curtainImageUrl1', 'curtainImageUrl2', 'curtainImageUrl3', 'curtainImageUrl4', 'curtainImageUrl5'],
      design: {}
    };
  },

  mounted() {
    const height = document.body.clientHeight;
    this.height = height;
    this.getStyleData();
  },
  methods: {
    setFormData(info){
      this.productInfo ={
        ...this.productInfo,
        ...info
      }
      // debugger
        this.$store.commit("ADD_MAINLIAO_CARTS", this.productInfo);
    },
    setModalState(v) {
      this.showDetailModal = v;

    },
    saveMianLiao(info) {


    },
    back() {
      history.go(-1)
    },
    onClickButton() {
      this.productInfoTemp = this.productInfo
      this.showDetailModal = true;
    },
    onClickIcon() {
      this.$router.replace('/cart?activeHeader=mianliao')
    },
    getStyleData() {
      const id = this.$route.query.id;
      this.$http.post("/public/productDetail", id).then(res => {
        this.imgs = this.imgs.filter((item) => res[item])
        this.productInfo = res||{}
        document.title = this.productInfo.number
      });
    }
  }
};
</script>
<style scoped>
.product-detail .info {

  padding: 10px 20px;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 20px;

}

.product-detail img {
  max-width: 100%;
}

.product-detail .title {
  font-weight: 600;
  font-size:16px;
}

.product-detail .menfu {
  color: #e48f81;
  font-size: 12px;
  margin-top: 10px;
}

.product-detail .desc {
  display: flex;
  font-size: 12px;
  font-size: 12px;
  margin-top: 10px;
  color: #666;
}

.back-icon {
  background: #10111163;
  width: 20px;
  /* padding: 8px 0; */
  border-radius: 100%;
  text-align: center;
  color: #fff;
  font-weight: 600;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
}
.total{
  flex: 0 0 100px;
  font-size: 12px;
  text-align: center;
}
.total span{
  font-size: 18px;
}
</style>
